import { render, staticRenderFns } from "./DraftSaver.vue?vue&type=template&id=1b682c53"
import script from "./DraftSaver.vue?vue&type=script&lang=js"
export * from "./DraftSaver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports